import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { Lock, User, Eye, EyeOff } from 'lucide-react';
import { API_BASE_URL } from '../config';

const LOGIN_URL = `${API_BASE_URL}/auth/login`;

const AdminLoginPage = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!username || !password) {
      toast.error('Por favor, rellena todos los campos');
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(LOGIN_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
      });

      if (!response.ok) throw new Error('Credenciales incorrectas');

      const userData = await response.json();
      
      localStorage.setItem('voltaris_user', JSON.stringify(userData));
      
      toast.success('Acceso correcto');
      
      // Navegación tras login exitoso
      navigate('/admin/users', { replace: true });
    } catch (error) {
      toast.error('Usuario o contraseña incorrectos');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-900 flex flex-col justify-center py-12 px-4">
      <div className="max-w-md w-full mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-2xl font-bold text-white">Voltaris Industry</h2>
          <p className="text-sm text-slate-400">Panel de Administración Central</p>
        </div>
        <div className="bg-white py-8 px-6 shadow rounded-lg">
          <form className="space-y-6" onSubmit={handleLogin}>
            <div>
              <label className="block text-sm font-semibold text-slate-700">Usuario</label>
              <div className="mt-1 relative">
                <div className="absolute left-3 top-3 text-slate-400"><User size={18} /></div>
                <input
                  type="text"
                  value={username}
                  data-testid="login-username-input"
                  onChange={(e) => setUsername(e.target.value)}
                  className="block w-full pl-10 py-2 border border-slate-300 rounded-md focus:ring-primary focus:border-primary text-sm"
                  placeholder="Usuario"
                />
              </div>
            </div>
            <div>
              <label className="block text-sm font-semibold text-slate-700">Contraseña</label>
              <div className="mt-1 relative">
                <div className="absolute left-3 top-3 text-slate-400"><Lock size={18} /></div>
                <input
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  data-testid="login-password-input"
                  onChange={(e) => setPassword(e.target.value)}
                  className="block w-full pl-10 pr-10 py-2 border border-slate-300 rounded-md focus:ring-primary focus:border-primary text-sm"
                  placeholder="••••••••"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-3 text-slate-400 hover:text-slate-600"
                >
                  {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                </button>
              </div>
            </div>
            <button
              type="submit"
              disabled={loading}
              data-testid="login-submit-button"
              className="w-full py-2.5 bg-primary text-white font-bold rounded-md hover:bg-primary/90 transition-all disabled:opacity-50"
            >
              {loading ? 'Accediendo...' : 'Acceder al CMS'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminLoginPage;